import type { FunnelPriceSnapshot } from '../../../lib/funnel-prices';

export function FunnelPriceNotice({ snapshot }: { snapshot: FunnelPriceSnapshot }) {
  if (snapshot.source === 'live') return null;

  const message = snapshot.source === 'stale'
    ? 'Price check is being refreshed. Review the current amount before continuing.'
    : 'Price check is temporarily unavailable. The displayed amount is a fallback and is not a current quote.';

  return (
    <p
      data-testid="funnel-price-notice"
      role="status"
      className="rounded-md border border-brand-teal/20 bg-brand-teal/[0.06] px-4 py-3 text-center text-sm leading-6 text-slate-400"
    >
      {message}
    </p>
  );
}
